import React from 'react';
import { getDic } from '../../assets/i18n/dictionary';
import {
  FormRow,
  FormColumn,
  TextMedium,
} from '../../components';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const EndMessage = (props) => {
  const {
    dimensions,
    configOptions,
  } = props;

  const width = dimensions.width < 640 ? dimensions.width - 40 : 600;

  return (
    <FormColumn height={dimensions.height - 300} padding={10} justifyContent='center' alignItems='center'>
      <FormRow width={width} justifyContent='center'>
        <TextMedium color={configOptions.textColor}>
          {getDic("face-collector-step-5-a")}
        </TextMedium>
      </FormRow>
      <FormRow width={width} justifyContent='center' paddingTop={20}>
        <CheckCircleOutlineIcon style={{ fontSize: 120, color: configOptions.textColor }} />
      </FormRow>
      <FormRow width={width} justifyContent='center' paddingTop={20}>
        <TextMedium color={configOptions.textColor}>
          {getDic("esta-pagina-pode-ser-fechada")}
        </TextMedium>
      </FormRow>
    </FormColumn>
  )
};

export default EndMessage;
